import Swal from 'sweetalert2'
import {
    GET_USER_INFO,
    GET_MY_COMMUNITIES_AND_CATEGORY,
    IS_LOADING_GET_MY_COMMUNITIES_AND_CATEGORY,
    LOAD_RELATION_BETWEEN,
    GET_USER_POSTS,
    IS_LOADING_DATA_PROFILE,
    GET_RELATION_BETWEEN,
    IS_LOADING_GET_USER_INFO,
    IS_LOADING_POSTS,
    GET_USER_ALBUMS,
    IS_LOADING_GET_USER_ALBUMS,
    GET_ALBUM_INFO,
    POST_ALBUM_INFO,
    BACK_TO_VIEW_ALBUMS,
    GET_TYPE_OF_REPORT,
    IS_LOADING_GET_TYPE_OF_REPORT,
    IS_LOADING_GET_MY_ROOMS,
    GET_MY_ROOMS,
    DELETE_ADMIN_ROOM,
    GET_ROOM_INFO,
    IS_LOADING_GET_MEMBERS_ROOM,
    GET_MEMBERS_ROOM,
    IS_LOADING_GET_ALL_ROOMS,
    GET_ALL_ROOMS,
    GET_ALL_ROOMS_FILTER,
    IS_LOADING_GET_MY_COMMUNITIES,
    GET_MY_COMMUNITIES,
    DELETE_MY_COMMUNITY,
    GET_COMMUNITY_INFO,
    IS_LOADING_GET_COMMUNITY_REQUESTS,
    GET_COMMUNITY_REQUESTS,
    ACCEPT_COMMUNITY_REQUEST,
    CANCEL_COMMUNITY_REQUEST,
    IS_LOADING_GET_COMMUNITY_MEMBERS,
    GET_COMMUNITY_MEMBERS,
    IS_LOADING_GET_COMMUNITY_MEMBERS_REJECTED,
    GET_COMMUNITY_MEMBERS_REJECTED,
    IS_LOADING_GET_ROOM_REQUESTS,
    GET_ROOM_REQUESTS,
    IS_LOADING_GET_USER_REQUESTS_FROM_ROOM,
    GET_USER_REQUESTS_FROM_ROOM,
    REMOVE_ROOM_REQUEST,
    IS_LOADING_GET_ROOMS_I_BELONG,
    GET_ROOMS_I_BELONG,
    REMOVE_REQUEST_FROM_ROOM,
    BLOCK_COMMUNITY_USER,
    IS_LOADING_COMMUNITY_BY_CATEGORIES,
    COMMUNITIES_BY_CATEGORY,
    REMOVE_COMMUNITY_MEMBER,
    IS_LOADING_GET_COMMUNITY_MEMBERS_BLOCKED,
    GET_COMMUNITY_MEMBERS_BLOCKED,
    DELETE_MANAGER_COMMUNITY,
    GET_MANAGER_COMMUNITY_INFO,
    IS_LOADING_GET_MANAGER_COMMUNITY_LIST,
    GET_MANAGER_COMMUNITY_LIST,
    IS_LOADING_LIST_MY_POST_REPORTED,
    IS_LOADING_MY_LIST_COMMUNITY_REPORTED,
    MY_LIST_COMMUNITY_REPORTED,
    LIST_MY_POST_REPORTED,
    CHANGE_MY_POST_REPORTED,
    IS_LOADING_POST_INFO,
    POST_INFO,
    LIST_POST_I_REPORTED,
    IS_LOADING_LIST_POST_I_REPORTED_FROM_LIST,
    CANCEL_POST_I_REPORTED_FROM_LIST,
    DELETE_CLASSIFIED,
    IS_LOADING_CLASSIFIED_INFO,
    CLASSIFIED_INFO,
    IS_LOADING_LOCATION_COUNTRY,
    LOCATION_COUNTRY,
    IS_LOADING_LOCATION_CITIES,
    LOCATION_CITIES,
    IS_LOADING_LOCATION_STATE,
    LOCATION_STATE,
    IS_LOADING_GET_MY_ROOMS_AND_CATEGORY,
    GET_MY_ROOMS_AND_CATEGORY,
    IS_LOADING_LIST_CLASSIFIEDS,
    LIST_CLASSIFIEDS,
    IS_LOADING_SELLER_RATE,
    SELLER_RATE,
    CHANGE_SELLER_RATE,
    IS_LOADING_LIST_CLASSIFIED_SAVED,
    LIST_CLASSIFIED_SAVED,
    IS_LOADING_LIST_POST_SAVED,
    LIST_POST_SAVED,
    REMOVE_CLASSIFIED_SAVED,
    REMOVE_POST_SAVED,
    IS_LOADING_CLASSIFIEDS_IMAGES,
    DELETE_CLASSIFIED_IMAGE,
    CLASSIFIED_IMAGES,
    IS_LOADING_USER_CHALLENGES,
    USER_CHALLENGES,
    IS_LOADING_USER_BADGES,
    USER_BADGES,
    IS_LOADING_LIST_CLASSIFIEDS_OTHERS,
    LIST_CLASSIFIEDS_OTHERS,
    IS_LOADING_LIST_PQRS_USER,
    CREATE_PQRS_USER,
    LIST_PQRS_USER,
    IS_LOADING_PAYMENT_USER,
    PAYMENT_USER,
    IS_LOADING_LIST_POST_PENDING_COMMUNITY,
    LIST_POST_PENDING_COMMUNITY,
    CHANGE_STATUS_PENDING_COMMUNITY,
    IS_LOADING_BLOCK_VENDOR_LIST,
    UNBLOCK_VENDOR,
    BLOCK_VENDOR_LIST,
    IS_LOADING_STORIES_LIST,
    STORIES_LIST,
    IS_LOADING_CREATE_STORY,
    CREATE_STORY,
    DELETE_STORY,
    IS_LOADING_ARCHIVED_STORIES_LIST,
    ARCHIVED_STORIES_LIST,
    IS_LOADING_LIST_COMMUNITY_I_REPORTED_FROM_LIST,
    CANCEL_COMMUNITY_I_REPORTED_FROM_LIST,
    IS_LOADING_LIST_COMMUNITY_I_REPORTED,
    CANCEL_COMMUNITY_I_REPORTED,
    COMMUNITY_I_REPORTED_LIST,
    CHANGE_STATUS_COMMUNITY_REPORTED,
    DISABLE_PQRS_USER,
    IS_LOADING_USER_RANKING,
    USER_RANKING,
    IS_LOADING_GET_ALBUM_INFO,
    IS_LOADING_POST_ALBUM,
    PROFESSIONAL_IS_LOADING_DATA_PROFILE,
    PROFESSIONAL_GET_USER_POSTS,
    ASIGN_MANAGER_TYPE,
    UNBLOCK_COMMUNITY_MEMBER,
    IS_LOADING_PRIVATE_USER_INFO,
    UPDATE_PRIVATE_USER_INFO,
    IS_LOADING_STORY_INFO,
    STORY_INFO,
    SEE_COMMENTS, IS_NOT_LOADING_GET_USER_ALBUMS,
    UN_ARCHIVED_STORY,
    CLEAR_POST_INFO,
    ADD_TO_ROOMS_I_BELONG,
    CLEAR_ROOM_INFO,
    DELETE_MEMBER_ROOM,
    IS_LOADING_GET_ROOM_INFO,
    ERROR_GET_ROOM_INFO,
    ERROR_GET_COMMUNITY_INFO,
    IS_LOADING_GET_COMMUNITY_INFO,
    CHECK_USER_IN_COMMUNITY,
    LOADING_CHECK_USER_IN_COMMUNITY,
    CHECK_USER_IN_ROOM,
    LOADING_CHECK_USER_IN_ROOM,
    CLEAR_POST_ALBUM_INFO,
    CLEAR_POST_ALBUMS,
    LOAD_STIKERS,
    GET_STIKERS,
    GET_ZONE_POSTS,
    CLEAR_USER_IN_COMMUNITY,
    DELETE_POST,
    DELETE_ALBUM

} from './types'
import {
    urlServer
} from '../config/GlobalConstant'
import inMemoryJWT from '../auth/inMemoryJwt';
import localStorage from '../utils/hooks/useLocalStorage';

//user actions, everything that a user interacts with on the platform such as classifieds, rooms, among others.


const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})


/* ---------------------------------------*/
/* ---------->>> USER INFO <<<-----------*/
/* ---------------------------------------*/

export const changePicture = (picture) =>  dispatch => {

}
export const getUserInfo = (idUser, inProfile = false) => async dispatch => {
    dispatch({
        type: IS_LOADING_GET_USER_INFO //reducer
    });

    await fetch(`${urlServer}users/get-user-id`, {
        withCredentials: true,
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            userID: idUser
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log();

            console.log()
            var dataUser = respJson.data
            console.log()
            if (inProfile) {
                dispatch({
                    type: "GET_PROFILE_INFO",
                    payload: { counters: dataUser.counters, user: dataUser.user, reported: dataUser.reported } // information to reducer
                });
            } else {
                dispatch({
                    type: GET_USER_INFO,
                    payload: { counters: dataUser.counters, user: dataUser.user, reported: dataUser.reported } // information to reducer
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const getCountersUserInfo = (idUser, inProfile = false) => async dispatch => {

    await fetch(`${urlServer}social/social-count`, {
        withCredentials: true,
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            entityID: idUser
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log();

            console.log()
            var dataUser = respJson.data
            console.log()
            if (inProfile) {
                dispatch({
                    type: "GET_PROFILE_INFO_COUNTER",
                    payload: { counters: dataUser } // information to reducer
                });
            } else {
                dispatch({
                    type: "GET_USER_INFO_COUNTER",
                    payload: { counters: dataUser } // information to reducer
                });
            }

        })
        .catch(error => {
            console.log()
        })
}
export const changeUserPrivacy = (privacyUser) => async dispatch => {
    await fetch(`${urlServer}api/user/update-privacy`, {
        withCredentials: true,
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(privacyUser)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Actualización exitosa'
                })
            }
            dispatch({
                type: IS_LOADING_PRIVATE_USER_INFO //reducer
            });
            console.log()
            var dataUser = respJson.data
            console.log()
            dispatch({
                type: UPDATE_PRIVATE_USER_INFO,
                payload: dataUser // information to reducer
            });
        })
        .catch(error => {
            console.log()
        })
}

// get user publications
export const getUserPost = (idUser, isProfessional, isMark) => async dispatch => {


    isProfessional ? await fetch(`${urlServer}api/professionalpost/professional-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            professionalProfileID: idUser,
            visitorID: localStorage().getItem('professionalID')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            console.log()
            dispatch({
                type: PROFESSIONAL_IS_LOADING_DATA_PROFILE,
            })
            var dataPost = respJson.data
            dispatch({
                type: PROFESSIONAL_GET_USER_POSTS,
                payload: dataPost || []
            })
        })
        .catch(error => {
            console.log()
        }) :
        await fetch(`${urlServer}posts/get-post-user`, {

            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                visitedId: idUser
            })
        })
            .then(response => response.json())
            .then(respJson => {
             
                dispatch({
                    type: IS_LOADING_DATA_PROFILE,
                })
                var dataPost = respJson.data
                dispatch({
                    type: GET_USER_POSTS,
                    payload: dataPost || []
                })

            })
            .catch(error => {
                console.log()
            })
}
export const getUserPostWhitOutCampaings = (idUser, isProfessional, isMark) => async dispatch => {


    isProfessional ? await fetch(`${urlServer}api/professionalpost/professional-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            professionalProfileID: idUser,
            visitorID: localStorage().getItem('professionalID')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            console.log()
            dispatch({
                type: PROFESSIONAL_IS_LOADING_DATA_PROFILE,
            })
            var dataPost = respJson.data
            dispatch({
                type: PROFESSIONAL_GET_USER_POSTS,
                payload: dataPost || []
            })
        })
        .catch(error => {
            console.log()
        }) :
        await fetch(`${urlServer}posts/get-post-user`, {

            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',

            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                visitedId: idUser
            })
        })
            .then(response => response.json())
            .then(respJson => {
                /* console.log()
                console.log() */
                dispatch({
                    type: IS_LOADING_DATA_PROFILE,
                })
                var dataPost = respJson.data
                dispatch({
                    type: GET_USER_POSTS,
                    payload: dataPost || []
                })

            })
            .catch(error => {
                console.log()
            })
}

//Edit user info
export const editUserInfo = (userEditInfo, history) => async dispatch => {


    // userEditInfo['id'] = userID
    console.log()
    await fetch(`${urlServer}users/update`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(
            userEditInfo
        )
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {

                Toast.fire({
                    icon: 'success',
                    title: 'Actualización exitosa'
                })
                localStorage().setItem("nameUser", userEditInfo.name)
                localStorage().setItem("lastNameUser", userEditInfo.lastName)
                dispatch({
                    type:"SET_USER_INFO",
                    payload:respJson.data
                })
                history.push(`/Profile/${respJson.data._id}`)
            }
            console.log()
        })
        .catch(error => {
            console.log()
        })
}

// get relationship between 2 users
export const getRelationBetween = (secondID, isProfessional) => async dispatch => {

    dispatch({
        type: LOAD_RELATION_BETWEEN
    })

    await fetch(`${urlServer}social/${isProfessional ? 'professional-byids' : 'byids'}`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({

            secondID
            // type: 1
        })
    })
        .then(response => response.json())
        .then(respJson => {

            // console.log()

            dispatch({
                type: GET_RELATION_BETWEEN,
                payload: respJson.data
            })
        })
        .catch(error => {
            console.log()
        })
}

// delete publications
export const deletePost = (id, index, history, idZone) => async dispatch => {

    console.log()
    await fetch(`${urlServer}${!!idZone ? "zoneposts/delete" : "posts/delete"}`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            postId: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            dispatch({
                type: IS_LOADING_POSTS,
            })
           // if (index < 0) {
                if (!!idZone) {
                    history.push("/Zones/Zone/" + idZone._id)
                } else {
                    dispatch({
                        type: DELETE_POST,
                        payload:id
                    })
                    history.push("/")
                }

    //        } else {
  //              history.go(0)
//            }
            console.log()


        })
        .catch(error => {
            console.log()
        })
}

// edit user publications
export const editPost = (postEdited, clear) => async dispatch => {

    await fetch(`${urlServer}posts/update`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(postEdited)
    })
        .then(response => response.json())
        .then(respJson => {

            if (respJson.success === true) {
                clear()
                Toast.fire({
                    icon: 'success',
                    title: 'Actualización exitosa'
                })
            }
            console.log()
        })
        .catch(error => {
            console.log()
        })
}


/* ---------------------------------------*/
/* ---------->>> ALBUM MANAGEMENT <<<-----------*/
/* ---------------------------------------*/

export const addAlbum = (album, history) => async dispatch => {
    await fetch(`${urlServer}albums/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(album)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === false) {
                Toast.fire({
                    icon: 'error',
                    title: 'El registro ya existe'
                })
            }
            history.push({
                pathname: '/Profile/' + respJson.data.entityID + '/Album/' + respJson.data._id,
                state: {
                    album: respJson.data
                }
            })
        })
        .catch(error => {
            console.log()
        })
}

export const getUserAlbums = (id) => async dispatch => {

    dispatch({
        type: IS_LOADING_GET_USER_ALBUMS
    });

    await fetch(`${urlServer}albums/get-any-user`, {

        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            entityID: id
        })
    })
        .then(response => response.json())
        .then(respJson => {

            if (!respJson.success) throw respJson;

            console.log();

            dispatch({
                type: GET_USER_ALBUMS,
                payload: { data: respJson.data, id }
            });
        })
        .catch(error => {
            console.log();
            dispatch({
                type: IS_NOT_LOADING_GET_USER_ALBUMS
            });
        })
}

export const getAlbum = (id) => async dispatch => {

    await fetch(`${urlServer}albums/get-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            albumID: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_GET_ALBUM_INFO,
            });
            dispatch({
                type: GET_ALBUM_INFO,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const editAlbum = (albumEdited, history) => async dispatch => {
    await fetch(`${urlServer}albums/update`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(albumEdited)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                console.log()
                Toast.fire({
                    icon: 'success',
                    title: 'Actualización exitosa'
                })

                history.go(-1)
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getAlbumPosts = (albumData) => async dispatch => {
    console.log()
    await fetch(`${urlServer}albums/get-album-user-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(albumData)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_POST_ALBUM
            });
            dispatch({
                type: POST_ALBUM_INFO,
                payload: {
                    data: respJson.data,
                    albumData: albumData.albumID,
                    id: albumData.entityID,
                }
            });
        })
        .catch(error => {
            console.log()
        })
}
export const clearAlbumPosts = () => dispatch => {
    dispatch({
        type: CLEAR_POST_ALBUM_INFO
    });

}
export const clearAlbums = () => dispatch => {
    dispatch({
        type: CLEAR_POST_ALBUMS
    });

}


export const backToViewAlbums = (history) => dispatch => {
    dispatch({
        type: BACK_TO_VIEW_ALBUMS
    })
}



export const deleteAlbum = (id,  history, isInList) => async dispatch => {
    //    console.log()
  //  history.push('../MyAlbums')



     
        await fetch(`${urlServer}albums/delete`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${inMemoryJWT.getToken()}`
                // 'Content-Type': 'application/x-www-form-urlencoded',
    
            }, // body data type must match "Content-Type" header    
            body: JSON.stringify({
                albumID: id
            })
        })
            .then(response => response.json())
            .then(respJson => {
                console.log()
                if (respJson.success === true) {
                    dispatch({
                        type: IS_LOADING_GET_USER_ALBUMS
                    });
                    dispatch({
                        type: DELETE_ALBUM,
                        payload: id
                    });
                  /*   if(!isInList){
                        history.push('../')
                    } */
    
                }
            })
            .catch(error => {
                console.log()
            }) 
}

export const movePostAlbum = (body, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/post/move`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(body)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                history.push('/SeeAlbums')
            }
        })
        .catch(error => {
            console.log()
        })
}


/* ---------------------------------------*/
/* ---------->>> REPORTS MANAGEMENT <<<-----------*/
/* ---------------------------------------*/

export const getTypeOfReports = () => async dispatch => {
    dispatch({
        type: IS_LOADING_GET_TYPE_OF_REPORT
    });

    await fetch(`${urlServer}admintypeofreports/get-all`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    

    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: GET_TYPE_OF_REPORT,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })
}
export const reportUser = (userID) => async dispatch => {
    await fetch(`${urlServer}entityreports/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(userID)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })
                Toast.fire({
                    icon: 'success',
                    title: 'Reporte realizado exitosamente'
                })
            }
            else {
                console.log();
                Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })
                Toast.fire({
                    icon: 'error',
                    title: respJson.error.code ? 'Ya reportaste este perfil' : 'Fallo al realizar el reporte'
                })
            }

        })
        .catch(error => {
            console.log()
        })
}
export const reportUserZoneRoom = (userID) => async dispatch => {
    await fetch(`${urlServer}roomzonereports/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(userID)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })
                Toast.fire({
                    icon: 'success',
                    title: 'Reporte realizado exitosamente'
                })
            }
            else {
                console.log();
                Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })
                Toast.fire({
                    icon: 'error',
                    title: respJson.error.code ==="ERR056" ? 'Ya reportaste este perfil' : 'Fallo al realizar el reporte'
                })
            }

        })
        .catch(error => {
            console.log()
        })
}
export const reportPost = (postID) => async dispatch => {
    console.log()
    await fetch(`${urlServer}contentreports/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(postID)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })
                Toast.fire({
                    icon: 'success',
                    title: 'Reporte realizado exitosamente'
                })
            }
            else {
                Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })
                Toast.fire({
                    icon: 'error',
                    text: respJson.error.code,
                    title: respJson.error.code ==="ERR056" ? 'Ya reportaste este contenido' : 'Fallo al realizar el reporte'
                })
            }

        })
        .catch(error => {
            console.log()
        })
}
export const apeleReport = (contentReportID, objection, action) => async dispatch => {
    await fetch(`${urlServer}contentreports/change-state`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            status: 3,
            contentReportID,
            objection
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                action()
            }


        })
        .catch(error => {
            console.log()
        })
}
export const acepeReport = (contentReportID, action) => async dispatch => {
    await fetch(`${urlServer}contentreports/change-state`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            status: 2,
            contentReportID,

        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                action()
            }


        })
        .catch(error => {
            console.log()
        })
}


export const getMyListPostReported = () => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/postreport/user-reported-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            entityID: localStorage().getItem('idUser')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_LIST_MY_POST_REPORTED
            });
            dispatch({
                type: LIST_MY_POST_REPORTED,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })
}

export const getListPostIReported = () => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/postreport/user-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            entityID: localStorage().getItem('idUser')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_LIST_POST_I_REPORTED_FROM_LIST
            });
            dispatch({
                type: LIST_POST_I_REPORTED,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })
}
export const cancelPostIReportedFromList = (idReport, index) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/postreport/delete-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            id: idReport,
            entityID: localStorage().getItem('idUser')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_LIST_POST_I_REPORTED_FROM_LIST
                });
                dispatch({
                    type: CANCEL_POST_I_REPORTED_FROM_LIST,
                    payload: index
                });
            }

        })
        .catch(error => {
            console.log()
        })
}


export const changeMyListPostReported = (changeReport, index) => async dispatch => {

    await fetch(`${urlServer}api/postreport/change-state-user`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(changeReport)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_LIST_MY_POST_REPORTED
            });
            dispatch({
                type: CHANGE_MY_POST_REPORTED,
                payload: {
                    changeReport,
                    index
                }
            });

        })
        .catch(error => {
            console.log()
        })
}

//get information of publication
export const clearPostInfo = () => async dispatch => {
    dispatch({
        type: CLEAR_POST_INFO,
    })
    dispatch({
        type: SEE_COMMENTS,
        payload: []
    })
}

export const getPostInfo = (postID, isProfessional) => async dispatch => {
    dispatch({
        type: IS_LOADING_DATA_PROFILE,
    });

    dispatch({
        type: IS_LOADING_POST_INFO
    });

    await fetch(`${urlServer}${isProfessional ? 'professionalpost/id' : 'posts/get-id'}`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            //  postID: postID,
          
            //textString: "",
            //model: "post",
            postId: postID
        })
    })
        .then(response => response.json())
        .then(respJson => {
            //  console.log()

            dispatch({
                type: POST_INFO,
                payload: respJson.data || []
            })
            /* dispatch({
                type: IS_LOADING_POST_INFO
            });
            dispatch({
                type: POST_INFO,
                payload: respJson.data
            }); */

        })
        .catch(error => {
            console.log()
        })
}
export const getPostZoneInfo = (postID, isProfessional) => async dispatch => {
    dispatch({
        type: IS_LOADING_DATA_PROFILE,
    });

    dispatch({
        type: IS_LOADING_POST_INFO
    });

    await fetch(`${urlServer}${isProfessional ? 'professionalpost/id' : 'zoneposts/get-by-id'}`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            //  postID: postID,
            //  visitedId: isProfessional ? localStorage().getItem("professionalID") : localStorage().getItem('idUser')
            //textString: "",
            //model: "post",
            postId: postID
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()

            dispatch({
                type: POST_INFO,
                payload: [respJson.data] || []
            })
            /* dispatch({
                type: IS_LOADING_POST_INFO
            });
            dispatch({
                type: POST_INFO,
                payload: respJson.data
            }); */

        })
        .catch(error => {
            console.log()
        })
}


/* ---------------------------------------*/
/* ---------->>>USER ROOM/CHATS MANAGEMENT <<<-----------*/
/* ---------------------------------------*/
export const requestToRom = (id, history) => async dispatch => {
    await fetch(`${urlServer}chats/add-member-room`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            chatRoomID: id,
            entityID: localStorage().getItem('idProfile')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success) {
                /*   dispatch({
                      type: ADD_TO_ROOMS_I_BELONG,
                      payload: respJson.data
                  }); */
                // dispatch(clearRoom());
                // history.push("/Rooms/Room/"+respJson.data._id)
            }

        })
        .catch(error => {
            console.log()
        })

}
export const joinToRom = (id, idUser, history) => async dispatch => {
    await fetch(`${urlServer}chats/add-member-room`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            chatRoomID: id,
            entityID: idUser
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success) {
                dispatch({
                    type: ADD_TO_ROOMS_I_BELONG,
                    payload: respJson.data
                });
                dispatch(clearRoom());
                history.push("/Rooms/Room/" + id)
            }

        })
        .catch(error => {
            console.log()
        })

}
export const getCampaingsFranchise = (franchiseId) => async dispatch => {
    await fetch(`${urlServer}publiccampaigns/get-by-franchise`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            franchiseId: franchiseId
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success) {
                dispatch({
                    type: "GET_CAMPAIGNS_FRANCHISEE",
                    payload: respJson.data
                })
                /*   dispatch({
                      type: ADD_TO_ROOMS_I_BELONG,
                      payload: respJson.data
                  });
                  history.push("/Rooms/Room/"+respJson.data._id) */
            }

        })
        .catch(error => {
            console.log()
        })

}
export const addMemberToRoom = (chatRoomID, userId, history) => async dispatch => {
    await fetch(`${urlServer}chats/add-member-room`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            chatRoomID: chatRoomID,
            entityID: userId
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success) {
                /*   dispatch({
                      type: ADD_TO_ROOMS_I_BELONG,
                      payload: respJson.data
                  });
                  history.push("/Rooms/Room/"+respJson.data._id) */
            }

        })
        .catch(error => {
            console.log()
        })

}


export const getAllRooms = (history) => async dispatch => {
    dispatch({
        type: IS_LOADING_GET_ALL_ROOMS
    });
    await fetch(`${urlServer}chats/get-all-rooms`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            entityID: localStorage().getItem('idUser')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success) {
                dispatch({
                    type: GET_ALL_ROOMS,
                    payload: respJson.data
                });
            } else {
                dispatch({
                    type: GET_ALL_ROOMS,
                    payload: []
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const getAllRoomsFilter = (filter, history) => async dispatch => {
    dispatch({
        type: IS_LOADING_GET_ALL_ROOMS
    });
    await fetch(`${urlServer}chats/search-rooms-category`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(filter)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.data.results) {
                dispatch({
                    type: GET_ALL_ROOMS_FILTER,
                    payload: respJson.data.results
                });

            } else {
                dispatch({
                    type: GET_ALL_ROOMS_FILTER,
                    payload: []
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const createRoom = (formData, history) => async dispatch => {
    for (var pair of formData.entries()) {
        console.log();
    }
    await fetch(`${urlServer}chats/create-room`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            //'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: formData
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                Toast.fire({
                    title: 'Sala creada'
                })
                history.push('/Rooms')
            }
            if (respJson.success === false && respJson?.error?.error?.code === 'ERR071') {
                Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })
                Toast.fire({
                    icon: 'error',
                    title: 'El nombre ya existe, debes colocar uno nuevo'
                })
            }
        })
        .catch(error => {
            console.log()
        })
}

export const seeMyRooms = () => async dispatch => {
    dispatch({
        type: IS_LOADING_GET_MY_ROOMS
    });
    await fetch(`${urlServer}chats/get-rooms-adminuser`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            adminID: localStorage().getItem('idProfile')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: GET_MY_ROOMS,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })
}

export const seeRoomsIBelong = () => async dispatch => {
    dispatch({
        type: IS_LOADING_GET_ROOMS_I_BELONG
    });
    await fetch(`${urlServer}chats/get-room-i-belong`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        // body: JSON.stringify({
        //     entityID: localStorage().getItem('idUser')
        // })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: GET_ROOMS_I_BELONG,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })
}


export const leaveRoomAdmin = (memberLeaving, index, history) => async dispatch => {
    console.log()
    dispatch({
        type: IS_LOADING_GET_MY_ROOMS
    });
    await fetch(`${urlServer}chats/delete-member-room`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(memberLeaving)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: DELETE_ADMIN_ROOM,
                payload: index
            });

        })
        .catch(error => {
            console.log()
        })
}
export const leaveRoom = (memberLeaving, index, isLeaveUser) => async dispatch => {
    //console.log()
    dispatch({
        type: IS_LOADING_GET_MEMBERS_ROOM
    });
    await fetch(`${urlServer}chats/delete-member-room`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(memberLeaving)
    })
        .then(response => response.json())
        .then(respJson => {


            dispatch({
                type: DELETE_MEMBER_ROOM,
                payload: respJson.data._id
            });

        })
        .catch(error => {
            console.log()
        })
}

export const assignMod = (memberToMod, index, isLeaveUser) => async dispatch => {
    //console.log()
    
  
    await fetch(`${urlServer}chats/assign-moderator`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(memberToMod)
    })
        .then(response => response.json())
        .then(respJson => {


            if (resetInfo.success) {
                if(memberToMod){
                    Toast.fire({
                        title:"Moderador asignado"
                    })
                }else{
                    Toast.fire({
                        title:"Moderador desasignado"
                    })
                }
                 dispatch({
                    type: GET_ROOM_INFO,
                    payload: respJson.data
                });
            }

        })
        .catch(error => {
            console.log()
        })
}


export const getRoom = (id, history) => async dispatch => {
    dispatch({
        type: IS_LOADING_GET_ROOM_INFO
    });
    await fetch(`${urlServer}chats/get-room-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            chatRoomID: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success) {
                dispatch({
                    type: GET_ROOM_INFO,
                    payload: respJson.data
                });
            } else {
                dispatch({
                    type: ERROR_GET_ROOM_INFO
                });
            }


        })
        .catch(error => {
            console.log()
        })
}
export const clearRoom = () => async dispatch => {
    dispatch({
        type: CLEAR_ROOM_INFO
    });
}
export const checkMemberInRoom = (idRoom, idUser, actionYes, actionNo) => async dispatch => {//chats/verify-member
    dispatch({
        type: LOADING_CHECK_USER_IN_ROOM
    });

    await fetch(`${urlServer}chats/verify-member`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            chatRoomID: idRoom,
            entityID: idUser
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success) {
                dispatch({
                    type: CHECK_USER_IN_ROOM,
                    payload: {
                        is: true,
                        roomId: idRoom
                    }
                })
                actionYes()
            } else {
                dispatch({
                    type: CHECK_USER_IN_ROOM,
                    payload: {
                        is: false,
                        roomId: idRoom
                    }
                })
                actionNo()
            }
        })
        .catch(error => {
            console.log()
        })
}
export const editRoom = (formData, history) => async dispatch => {
    for (var pair of formData.entries()) {
        console.log();
    }
    await fetch(`${urlServer}chats/update-room`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            //'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: formData
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {

                Toast.fire({
                    icon: 'success',
                    title: 'Actualización exitosa'
                })

                history.go(0)
            }
        })
        .catch(error => {
            console.log()
        })
}

export const deleteRoom = (id, history) => async dispatch => {

    dispatch({
        type: IS_LOADING_GET_MY_ROOMS
    });

    await fetch(`${urlServer}chats/delete-room`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            chatRoomID: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()

            dispatch({
                type: DELETE_ADMIN_ROOM,
                payload: id
            });
            history.push("Rooms")

        })
        .catch(error => {
            console.log()
        })
}

export const getMembersRoom = (id) => async dispatch => {
    console.log()
    dispatch({
        type: IS_LOADING_GET_MEMBERS_ROOM
    });
    await fetch(`${urlServer}chats/get-members-room`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            chatRoomID: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success) {
                dispatch({
                    type: GET_MEMBERS_ROOM,
                    payload: respJson.data
                });
            } else {
                dispatch({
                    type: GET_MEMBERS_ROOM,
                    payload: []
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const manageSocialRoom = (socialRoom, index, fromW) => async dispatch => {
    console.log()
    await fetch(`${urlServer}chats/actions`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(socialRoom)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true && respJson.data.mjse !== "Ya existe una solicitud pendiente" && (socialRoom.type === 0 || socialRoom.type === 1)) {
                Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })
                Toast.fire({
                    icon: 'success',
                    title: 'Se ha enviado la solicitud'
                })
            }
            if (respJson.success === true && respJson.data.code === "MSJ016" && (socialRoom.type === 0 || socialRoom.type === 1)) {
                Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })
                Toast.fire({
                    icon: '',
                    title: 'Ya existe una solicitud pendiente'
                })
            }

            if (respJson.success === true && (socialRoom.type === 2)) {
                Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })
                Toast.fire({
                    icon: 'success',
                    title: 'Solicitud aceptada'
                })
                if (fromW === 'roomRequest') {
                    dispatch({
                        type: IS_LOADING_GET_ROOM_REQUESTS
                    });
                    dispatch({
                        type: REMOVE_ROOM_REQUEST,
                        payload: index
                    });
                }
                if (fromW === 'requestFromRoom') {
                    dispatch({
                        type: IS_LOADING_GET_USER_REQUESTS_FROM_ROOM
                    });
                    dispatch({
                        type: REMOVE_REQUEST_FROM_ROOM,
                        payload: index
                    })
                }
                if (fromW === 'invite') {

                    dispatch({
                        type: CHECK_USER_IN_COMMUNITY,
                        payload: respJson.data
                    })
                }
            }
            if (respJson.success === true && (socialRoom.type === 3)) {
                Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })
                Toast.fire({
                    icon: 'success',
                    title: 'Solicitud cancelada'
                })
                if (fromW === 'roomRequest') {
                    dispatch({
                        type: IS_LOADING_GET_ROOM_REQUESTS
                    });
                    dispatch({
                        type: REMOVE_ROOM_REQUEST,
                        payload: index
                    });
                }
                if (fromW === 'requestFromRoom') {
                    dispatch({
                        type: IS_LOADING_GET_USER_REQUESTS_FROM_ROOM
                    });
                    dispatch({
                        type: REMOVE_REQUEST_FROM_ROOM,
                        payload: index
                    })
                }

            }
        })
        .catch(error => {
            console.log()
        })
}

export const sendMembersInvitations = (newMembers) => async dispatch => {

    await fetch(`${urlServer}chats/add-many-members-room`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(newMembers)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })
                Toast.fire({
                    icon: 'success',
                    title: 'Solicitudes enviadas'
                })
            }

        })
        .catch(error => {
            console.log()
        })
}

export const getRoomRequests = (id) => async dispatch => {
    /* dispatch({
        type: IS_LOADING_GET_ROOM_REQUESTS
    }) */
    console.log()
    await fetch(`${urlServer}chats/get-requests`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            chatRoomID: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()

            if (respJson.success) {
                dispatch({
                    type: GET_ROOM_REQUESTS,
                    payload: respJson.data
                });

            }
        })
        .catch(error => {
            console.log()
        })
}
export const getUserRequestsFromRoom = (history) => async dispatch => {

    dispatch({
        type: IS_LOADING_GET_USER_REQUESTS_FROM_ROOM
    });
    await fetch(`${urlServer}chats/get-invitations`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            entityID: localStorage().getItem('idProfile')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: GET_USER_REQUESTS_FROM_ROOM,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })
}


/* ---------------------------------------*/
/* ---------->>> USER COMMUNITY MANAGEMENT<<<-----------*/
/* ---------------------------------------*/

export const checkMemberInZone = (idZone, actionYes, actionNo) => async dispatch => {
    dispatch({ type: LOADING_CHECK_USER_IN_COMMUNITY })

    await fetch(`${urlServer}zonemembers/verify-member`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            zoneId: idZone,
            entityId: localStorage().getItem('idProfile')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                dispatch({
                    type: CHECK_USER_IN_COMMUNITY,
                    payload: respJson.data
                })

            }
        })
        .catch(error => {
            console.log()
        })
}

export const getUserPostcommuntiy = (idUser, isProfessional) => async dispatch => {

    await fetch(`${urlServer}zoneposts/get-by-zone`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            zoneId: idUser,
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            console.log()
            dispatch({
                type: IS_LOADING_DATA_PROFILE,
            })
            var dataPost = respJson.data
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: GET_ZONE_POSTS,
                payload: dataPost || []
            })
        })
        .catch(error => {
            console.log()
        })
}


export const getZoneAdministrators = (textString, entityRequired, history) => async dispatch => {
    await fetch(`${urlServer}users/get-zone-administrators`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`,
            'Content-Type': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            textString, entityRequired, limit: 10, skip: 0
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                dispatch({
                    type: 'GET_USERS_TO_ADMIN_ZONE',
                    payload: respJson.data
                })
            }
        })
}
export const clearZoneAdministrators = () => dispatch => {
    dispatch({
        type: 'CLEAR_USERS_TO_ADMIN_ZONE'
    })
}
export const createCommunity = (formData, history, isProfessional) => async dispatch => {
    for (var pair of formData.entries()) {
        console.log();
    }

    await fetch(`${urlServer}adminzones/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            //'Content-Type': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: formData
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                history.push(`/Admin/`)
            }

            if (respJson.success === false && respJson.error.code === 'ERR065') {
                Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })
                Toast.fire({
                    icon: 'error',
                    title: 'El nombre ya existe'
                })
            }

        })
        .catch(error => {
            console.log()
        })
}

export const getMyCommunities = (isProfessional) => async dispatch => {

    var url = isProfessional ? 'professionalcommunities/get/byprofessionalId' : 'communities/get/byuserId'
    var data = isProfessional ? {
        professionalId: localStorage().getItem('professionalID')
    } : {
        userId: localStorage().getItem('idUser')
    }
    console.log()
    await fetch(`${urlServer}adminzones/my-zones`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                type: IS_LOADING_GET_MY_COMMUNITIES
            });
            dispatch({
                type: GET_MY_COMMUNITIES,
                payload: respJson.data || []
            });
        })
        .catch(error => {
            console.log()
        })
}

export const getCommunitiesAndCategorys = (search, isProfessional) => async dispatch => {

    await fetch(`${urlServer}adminzones/get-all`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            searchCriteria: search,
            limit: 6
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_GET_MY_COMMUNITIES_AND_CATEGORY
            });
            dispatch({
                type: GET_MY_COMMUNITIES_AND_CATEGORY,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const getRoomsAndCategorys = (search) => async dispatch => {
    await fetch(`${urlServer}chats/search-rooms-category`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            search: search,
            limit: 100
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_GET_MY_ROOMS_AND_CATEGORY
            });
            dispatch({
                type: GET_MY_ROOMS_AND_CATEGORY,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}



export const deleteCommunity = (id, close) => async dispatch => {
    // console.log()



    await fetch(`${urlServer}adminzones/delete`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            zoneId: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success) {
                dispatch({
                    type: IS_LOADING_GET_MY_COMMUNITIES
                });
                dispatch({
                    type: DELETE_MY_COMMUNITY,
                    payload: id
                });

                close()
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getCommunity = (id, isProfessional) => async dispatch => {

    var url = isProfessional ? 'professionalcommunities' : ''
    dispatch({
        type: IS_LOADING_GET_COMMUNITY_INFO
    });
    await fetch(`${urlServer}adminzones/get-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(
            isProfessional ? {
                communityId: id,
                professionalId: localStorage().getItem('professionalID')
            } : {
                zoneId: id
            })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success) {
                dispatch({
                    type: GET_COMMUNITY_INFO,
                    payload: respJson.data
                });
            } else {
                dispatch({
                    type: ERROR_GET_COMMUNITY_INFO
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const editCommunity = (formData, history, isProfessional) => async dispatch => {
    for (var pair of formData.entries()) {
        console.log();
    }
    await fetch(`${urlServer}api/${isProfessional ? 'professionalcommunities' : 'communities'}/updatecommunity`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            //'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: formData
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Actualización exitosa'
                })
                history.push(`${isProfessional ? 'Professional' : ''}/Communities`)
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getCommunityRequests = (id) => async dispatch => {
    console.log()
    dispatch({
        type: IS_LOADING_GET_COMMUNITY_REQUESTS
    });
    await fetch(`${urlServer}zonemembers/get-zone-status`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            zoneId: id,
            status: 0,
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success) {
                dispatch({
                    type: GET_COMMUNITY_REQUESTS,
                    payload: respJson.data
                });
            } else {
                dispatch({
                    type: GET_COMMUNITY_REQUESTS,
                    payload: []
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const sendToCommunityARequest = (id, isProfessional) => async dispatch => {

    await fetch(`${urlServer}zonemembers/create-request`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            zoneId: id,
            invitation: false
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })
                Toast.fire({
                    icon: 'success',
                    title: 'Solicitud enviada'
                })
                dispatch({
                    type: CHECK_USER_IN_COMMUNITY,
                    payload: respJson.data
                });
            } else {
                Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })
                Toast.fire({
                    icon: 'error',
                    title: 'Ya enviaste una solicitud'
                })
            }

        })
        .catch(error => {
            console.log()
        })
}
export const sendToCommunityAInvite = (id, userId, clear) => async dispatch => {

    await fetch(`${urlServer}zonemembers/create-request`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            zoneId: id,
            userId: userId,
            invitation: true
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                clear()
                Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })
                Toast.fire({
                    icon: 'success',
                    title: 'Solicitud enviada'
                })
            } else {
                Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })
                Toast.fire({
                    icon: 'error',
                    title: 'Ya enviaste una solicitud'
                })
            }

        })
        .catch(error => {
            console.log()
        })
}

export const addMembersToZone = (members, zone, clear) => async dispatch => {

    await fetch(`${urlServer}zonemembers/add-many-members`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            zoneId: zone,
            members
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                clear()
                Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })
                Toast.fire({
                    icon: 'success',
                    title: 'Usuarios agregados'
                })
                if (respJson.data.find(member => member.code === "MSJ082") !== undefined) {
                    /*  Toast.fire({
                         icon: 'error',
                         title: 'Ya son miembros'
                     }) */
                }
            }

        })
        .catch(error => {
            console.log()
        })
}

export const acceptCommunityRequest = (id, invitation = false) => async dispatch => {


    await fetch(`${urlServer}zonemembers/manage-member`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            memberId: id,
            status: 2
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            /*    dispatch({
                   type: IS_LOADING_GET_COMMUNITY_REQUESTS
               });
               */
            if (respJson.success) {

                if (!invitation) {
                    Toast.fire({
                        icon: 'success',
                        title: 'Solicitud aceptada'
                    })
                    dispatch({
                        type: ACCEPT_COMMUNITY_REQUEST,
                        payload: id
                    });
                } else {
                    Toast.fire({
                        icon: 'success',
                        title: 'Invitación aceptada'
                    })
                    dispatch({
                        type: CHECK_USER_IN_COMMUNITY,
                        payload: respJson.data
                    });
                }

            }

        })
        .catch(error => {
            console.log()
        })
}

export const rejectCommunityRequest = (id, invitation = false) => async dispatch => {


    await fetch(`${urlServer}zonemembers/manage-member`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            memberId: id,
            status: 2
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            /*    dispatch({
                   type: IS_LOADING_GET_COMMUNITY_REQUESTS
               });
               */
            if (respJson.success) {

                if (!invitation) {
                    Toast.fire({
                        icon: 'success',
                        title: 'Solicitud aceptada'
                    })
                    dispatch({
                        type: ACCEPT_COMMUNITY_REQUEST,
                        payload: id
                    });
                } else {
                    Toast.fire({
                        icon: 'success',
                        title: 'Invitación aceptada'
                    })
                    dispatch({
                        type: CHECK_USER_IN_COMMUNITY,
                        payload: respJson.data
                    });
                }

            }

        })
        .catch(error => {
            console.log()
        })
}

export const cancelCommunityRequest = (id, index, isProfessional) => async dispatch => {
    console.log()

    await fetch(`${urlServer}zonemembers/manage-member`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            memberId: id,
            status: 1
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success) {
                Toast.fire({
                    icon: 'success',
                    title: 'Solicitud rechazada'
                })
                dispatch({
                    type: IS_LOADING_GET_COMMUNITY_REQUESTS
                });
                dispatch({
                    type: CANCEL_COMMUNITY_REQUEST,
                    payload: index
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const expellMerberZone = (id, index, isProfessional) => async dispatch => {
    console.log()

    await fetch(`${urlServer}zonemembers/manage-member`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            memberId: id,
            status: 3
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success) {
                Toast.fire({
                    icon: 'success',
                    title: 'Miembro expulsado'
                })

                dispatch({
                    type: REMOVE_COMMUNITY_MEMBER,
                    payload: id
                });
            }

        })
        .catch(error => {
            console.log()
        })
}


export const seeCommunityMembers = (id, isProfessional) => async dispatch => {
    console.log()
    dispatch({
        type: IS_LOADING_GET_COMMUNITY_MEMBERS
    });
    await fetch(`${urlServer}zonemembers/get-zone-status`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            zoneId: id,
            status: 2
        })
    })
        .then(response => response.json())
        .then(respJson => {

            if (respJson.success ===true) {
                dispatch({
                    type: GET_COMMUNITY_MEMBERS,
                    payload: respJson.data
                });
            } else {
                dispatch({
                    type: GET_COMMUNITY_MEMBERS,
                    payload: []
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const createManagerCommunity = (data, isProfessional) => async dispatch => {

    dispatch({
        type: IS_LOADING_GET_COMMUNITY_MEMBERS
    });
    await fetch(`${urlServer}api/${isProfessional ? 'professionalcommunities/professionals' : 'communities/manager'}/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
        })
        .catch(error => {
            console.log()
        })
}

export const seeCommunityMembersRejected = (id, isProfessional) => async dispatch => {
    console.log()
    dispatch({
        type: IS_LOADING_GET_COMMUNITY_MEMBERS_REJECTED
    });
    await fetch(`${urlServer}api/${isProfessional ? 'professionalcommunities' : 'communities'}/request/get/refuses/communityId`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            communityId: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: GET_COMMUNITY_MEMBERS_REJECTED,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })
}

export const blockCommunityUser = (blocked, index, history, fromWhere, isProfessional) => async dispatch => {

    await fetch(`${urlServer}api/${isProfessional ? 'professionalcommunities' : 'communities'}/request/blockUser`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(blocked)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (fromWhere === 'membersRejected') {
                dispatch({
                    type: IS_LOADING_GET_COMMUNITY_MEMBERS_REJECTED
                });
                dispatch({
                    type: BLOCK_COMMUNITY_USER,
                    payload: {
                        index,
                        fromWhere
                    }
                });
            }

            if (fromWhere === 'membersCommunity') {
                dispatch({
                    type: IS_LOADING_GET_COMMUNITY_MEMBERS
                });
                dispatch({
                    type: BLOCK_COMMUNITY_USER,
                    payload: {
                        index,
                        fromWhere
                    }
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const unblockCommunityMembers = (body, index, isProfessional) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/${isProfessional ? 'professionalcommunities' : 'communities'}/request/to-unlocked`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(body)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_GET_COMMUNITY_MEMBERS_BLOCKED
                });
                dispatch({
                    type: UNBLOCK_COMMUNITY_MEMBER,
                    payload: index
                });
            }

        })
        .catch(error => {
            console.log()
        })
}


export const seeCommunityMembersBlocked = (id, isProfessional) => async dispatch => {
    console.log()
    dispatch({
        type: IS_LOADING_GET_COMMUNITY_MEMBERS_BLOCKED
    });
    await fetch(`${urlServer}api/${isProfessional ? 'professionalcommunities' : 'communities'}/request/get/blocked/communityId`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            communityId: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: GET_COMMUNITY_MEMBERS_BLOCKED,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })
}

export const exitFromZone = (zoneId) => async dispatch => {
    await fetch(`${urlServer}zonemembers/expel-or-remove`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            zoneId,
            userId: localStorage().getItem('idProfile')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                dispatch({
                    type: CLEAR_USER_IN_COMMUNITY
                })
            }


        })
        .catch(error => {
            console.log()
        })
}
export const expelFromZone = (zoneId, id) => async dispatch => {
    await fetch(`${urlServer}zonemembers/expel-or-remove`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            zoneId,
            userId: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success) {
                dispatch({
                    type: REMOVE_COMMUNITY_MEMBER,
                    payload: id
                })

            }


        })
        .catch(error => {
            console.log()
        })
}

export const deleteCommunityMember = (deleted, index, history, fromWhere, isProfessional) => async dispatch => {

    await fetch(`${urlServer}api/${isProfessional ? 'professionalcommunities' : 'communities'}/request/delete/${isProfessional ? 'professionalId' : 'userId'}userId`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(deleted)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (fromWhere === 'membersRejected') {
                dispatch({
                    type: IS_LOADING_GET_COMMUNITY_MEMBERS_REJECTED
                });
                dispatch({
                    type: REMOVE_COMMUNITY_MEMBER,
                    payload: {
                        index,
                        fromWhere
                    }
                });
            }

            if (fromWhere === 'membersCommunity') {
                dispatch({
                    type: IS_LOADING_GET_COMMUNITY_MEMBERS
                });
                dispatch({
                    type: REMOVE_COMMUNITY_MEMBER,
                    payload: {
                        index,
                        fromWhere
                    }
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const getCommunityByCategories = (filter, isProfessional) => async dispatch => {
    console.log()
    dispatch({
        type: IS_LOADING_COMMUNITY_BY_CATEGORIES
    });
    await fetch(`${urlServer}api/${isProfessional ? 'professionalcommunities' : 'communities'}/get/bycategory`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(filter)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: COMMUNITIES_BY_CATEGORY,
                payload: respJson.data
            });

        })
        .catch(error => {
            console.log()
        })
}

/* -----------------------------------------------------*/
/* ---------->>> COMMUNITY MANAGER MANAGEMENT <<<-----------*/
/* -----------------------------------------------------*/
export const createCommunityManager = (manager, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/communities/manager/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(manager)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
        })
        .catch(error => {
            console.log()
        })
}

export const editCommunityManager = (managerEdited, isProfessional) => async dispatch => {
    await fetch(`${urlServer}api/${isProfessional ? 'professionalcommunities/professionals' : 'communities/manager'}/update`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(managerEdited)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Actualización exitosa'
                })
            }

        })
        .catch(error => {
            console.log()
        })
}

export const deleteCommunityManager = (id, index, isProfessional) => async dispatch => {

    await fetch(`${urlServer}api/${isProfessional ? 'professionalcommunities/professionals' : 'communities/manager'}/delete`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            id: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_GET_MANAGER_COMMUNITY_LIST
                });
                dispatch({
                    type: DELETE_MANAGER_COMMUNITY,
                    payload: index
                });
            }

        })
        .catch(error => {
            console.log()
        })
}


export const getCommunityManagerInfo = (id, isProfessional) => async dispatch => {
    await fetch(`${urlServer}api/${isProfessional ? 'professionalcommunities/professionals' : 'communities/manager'}/get/id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            id: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: GET_MANAGER_COMMUNITY_INFO,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}


export const getCommunityManagerList = (id, isProfessional) => async dispatch => {
    dispatch({
        type: IS_LOADING_GET_MANAGER_COMMUNITY_LIST
    });

    await fetch(`${urlServer}api/${isProfessional ? 'professionalcommunities/professionals' : 'communities/manager'}/get/communityId`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            communityId: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: GET_MANAGER_COMMUNITY_LIST,
                payload: respJson.data
            });
        })
        .catch(error => {
            console.log()
        })
}

export const asignTypeManager = (data, isProfessional, index, dataType) => async dispatch => {
    await fetch(`${urlServer}api/${isProfessional ? 'professionalcommunities/professionals' : 'communities/manager'}/asign/type`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(data)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            dispatch({
                type: IS_LOADING_GET_COMMUNITY_MEMBERS,
            });
            dispatch({
                type: ASIGN_MANAGER_TYPE,
                payload: { data: respJson.data, index, dataType: data.typeId ? dataType : false }
            });
        })
        .catch(error => {
            console.log()
        })
}



///posts in community

export const getPendingPostCommunity = (id, isProfessional) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/postrequest/community-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(isProfessional ? {
            professionalCommunityID: id
        } : {
            communityID: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_LIST_POST_PENDING_COMMUNITY
                });
                dispatch({
                    type: LIST_POST_PENDING_COMMUNITY,
                    payload: respJson.data
                });
            }

        })
        .catch(error => {
            console.log()
        })
}


export const changeStatusPendingPostCommunity = (status, index, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/postrequest/update-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(status)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_LIST_POST_PENDING_COMMUNITY
                });
                dispatch({
                    type: CHANGE_STATUS_PENDING_COMMUNITY,
                    payload: index
                });
            }

        })
        .catch(error => {
            console.log()
        })
}


/* -----------------------------------------------------*/
/* ---------->>> CERTIFICATION MANAGEMENT <<<-----------*/
/* -----------------------------------------------------*/


export const sendAccountCertificate = (formData, history) => async dispatch => {
    await fetch(`${urlServer}userauthrequests/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: formData
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Solicitud de certificación enviada'
                })
                history.push("/")
            }
            if (respJson.success === false) {
                Toast.fire({
                    icon: 'error',
                    title: 'Fallo al enviar la certificación'
                })
            }
        })
        .catch(error => {
            console.log()
        })
}

export const seeStateCertificate = (history) => async dispatch => {

    await fetch(`${urlServer}api/certificate/entity-auth`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            entityID: localStorage().getItem('idUser')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.data.state === 1) {
                Toast.fire({
                    icon: 'success',
                    title: 'En espera de respuesta'
                })
            }
            if (respJson.data.state === 2) {
                Toast.fire({
                    icon: 'error',
                    title: 'Autenticación rechazada. ' + 'Motivo: ' + respJson.data.invalidationReason
                })
            }
            if (respJson.data.state === 3) {
                Toast.fire({
                    icon: 'success',
                    title: 'Autenticacion aprobada'
                })
            }
        })
        .catch(error => {
            console.log()
        })
}

/* -----------------------------------------------------*/
/* ---------->>> CLASSIFIEDS MANAGEMENT <<<-----------*/
/* -----------------------------------------------------*/
export const createClassified = (classified, history) => async dispatch => {
    for (var pair of classified.entries()) {
        console.log();
    }
    await fetch(`${urlServer}api/classifieds/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            // 'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: classified
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                history.push('/Classified')
            }
        })
        .catch(error => {
            console.log()
        })
}

export const updateClassified = (classifiedEdited, history) => async dispatch => {

    for (var pair of classifiedEdited.entries()) {
        console.log();
    }

    await fetch(`${urlServer}api/classifieds/update-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            //'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: classifiedEdited
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {

                Toast.fire({
                    icon: 'success',
                    title: 'Actualización exitosa'
                })

                history.push('/Classified')
            }
        })
        .catch(error => {
            console.log()
        })
}

export const deleteClassified = (id, index, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/classifieds/delete-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            id: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_LIST_CLASSIFIEDS
                });
                dispatch({
                    type: DELETE_CLASSIFIED,
                    payload: index
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const deleteClassifiedImage = (imageDeleted, index, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/classifieds/delete-image`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(imageDeleted)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_CLASSIFIEDS_IMAGES
                });
                dispatch({
                    type: DELETE_CLASSIFIED_IMAGE,
                    payload: index
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getClassified = (id, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/classifieds/id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            id: id,
            visitorID: localStorage().getItem('idUser')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_CLASSIFIED_INFO
                });
                dispatch({
                    type: CLASSIFIED_INFO,
                    payload: respJson.data
                });
                dispatch({
                    type: IS_LOADING_CLASSIFIEDS_IMAGES
                });
                dispatch({
                    type: CLASSIFIED_IMAGES,
                    payload: respJson.data.multimedia
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getMyClassifiedList = (history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/classifieds/user-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify({
            userID: localStorage().getItem('idUser')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_LIST_CLASSIFIEDS
                });
                dispatch({
                    type: LIST_CLASSIFIEDS,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getClassifiedList = (list, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/classifieds/search`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify(list)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_LIST_CLASSIFIEDS_OTHERS
                });
                dispatch({
                    type: LIST_CLASSIFIEDS_OTHERS,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

/* --------------------------------------------------*/
/* ---------->>> LOCATIONS MANAGEMENT <<<-----------*/
/* --------------------------------------------------*/
export const getLocationCountries = (history) => async dispatch => {
    await fetch(`${urlServer}api/locations/get-countries`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_LOCATION_COUNTRY
                });
                dispatch({
                    type: LOCATION_COUNTRY,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}


export const getLocationState = (country, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/static-routes/locations/get-states`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify(country)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_LOCATION_STATE
                });
                dispatch({
                    type: LOCATION_STATE,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getLocationCities = (state, history) => async dispatch => {
    await fetch(`${urlServer}api/locations/get-cities`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify(state)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_LOCATION_CITIES
                });
                dispatch({
                    type: LOCATION_CITIES,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}



/* -----------------------------------------------------*/
/* ---------->>> SELLER RATING MANAGEMENT <<<-----------*/
/* -----------------------------------------------------*/
export const changeSellerRating = (rate, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/sellersrating/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(rate)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_SELLER_RATE
                });
                dispatch({
                    type: CHANGE_SELLER_RATE,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getSellerRating = (id, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/sellersrating/seller-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(id)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_SELLER_RATE
                });
                dispatch({
                    type: SELLER_RATE,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}


/* -----------------------------------------------------*/
/* ---------->>> CONTENT SAVED MANAGEMENT <<<-----------*/
/* -----------------------------------------------------*/

export const saveContent = (content, history) => async dispatch => {
    await fetch(`${urlServer}savedcontents/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify(content)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Contenido guardado'
                })
            }
            if (respJson.success === false) {
                if (respJson.error.code === "ERR032")
                    Toast.fire({
                        icon: 'error',
                        title: 'Este contenido ya se guardo'
                    })
            }
        })
        .catch(error => {
            console.log()
        })
}

export const seeContentSaved = (content, fromContent, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}savedcontents/get-user`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify(content)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true && fromContent === 'classifieds') {
                dispatch({
                    type: IS_LOADING_LIST_CLASSIFIED_SAVED
                });
                dispatch({
                    type: LIST_CLASSIFIED_SAVED,
                    payload: respJson.data || []
                });
            }

            if (respJson.success === true && fromContent === 'post') {
                dispatch({
                    type: IS_LOADING_LIST_POST_SAVED
                });
                dispatch({
                    type: LIST_POST_SAVED,
                    payload: respJson.data || []
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const removeContentSaved = (id, index, fromContent, history) => async dispatch => {
    await fetch(`${urlServer}savedcontents/delete`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify({
            savedContentID: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()

            if (respJson.success === true && fromContent === 'classifieds') {
                dispatch({
                    type: IS_LOADING_LIST_CLASSIFIED_SAVED
                });
                dispatch({
                    type: REMOVE_CLASSIFIED_SAVED,
                    payload: index
                });
            }

            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_LIST_POST_SAVED
                });
                dispatch({
                    type: REMOVE_POST_SAVED,
                    payload: index
                });
            }
        })
        .catch(error => {
            console.log()
        })
}


/* ------------------------------------------------------------*/
/* ---------->>> AWARDS AND CHALLENGES MANAGEMENT <<<-----------*/
/* ------------------------------------------------------------*/

export const userChallenges = (idUser) => async dispatch => {
    await fetch(`${urlServer}api/userchallenges/user-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify({
            userID: idUser
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_USER_CHALLENGES
                });
                dispatch({
                    type: USER_CHALLENGES,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}

export const userBadges = (id, history) => async dispatch => {
    await fetch(`${urlServer}api/userbadges/user-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify({
            userID: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_USER_BADGES
                });
                dispatch({
                    type: USER_BADGES,
                    payload: respJson.data
                });
            }
        })
        .catch(error => {
            console.log()
        })
}




/* -------------------------------------------------*/
/* ---------->>> PQRS USER MANAGEMENT <<<-----------*/
/* -------------------------------------------------*/

export const  sendUserPQRS = (pqrs, clear) => async dispatch => {
    await fetch(`${urlServer}pqrs/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        },
        body: JSON.stringify(pqrs)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Se envío correctamente'
                })
                dispatch({
                    type: IS_LOADING_LIST_PQRS_USER
                });
                dispatch({
                    type: CREATE_PQRS_USER,
                    payload: respJson.data
                });
                clear()
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getUserListPQRS = (user, history) => async dispatch => {
    await fetch(`${urlServer}pqrs/get-by-any-user`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                {
                    dispatch({
                        type: IS_LOADING_LIST_PQRS_USER
                    });
                    dispatch({
                        type: LIST_PQRS_USER,
                        payload: respJson.data
                    });
                }
            }
        })
        .catch(error => {
            console.log()
        })
}

export const getUserListTypePQRS = (type, index) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/pqrs/type`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(type)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_LIST_PQRS_USER
                });
                dispatch({
                    type: LIST_PQRS_USER,
                    payload: respJson.data
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const disablePQRS = (disable, index, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/pqrs/disable`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(disable)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_LIST_PQRS_USER
                });
                dispatch({ //Esto se lo envía a combineReducer, el que está en el index
                    type: DISABLE_PQRS_USER,
                    payload: index
                });
            }
        })
        .catch(error => {
            console.log()
        })
}


export const resetInfo = () => async dispatch => {
    console.log();
    dispatch({
        type: "CLEAR_PROFILE",
        payload: []
    })
    dispatch({
        type: GET_RELATION_BETWEEN,
        payload: {}
    })
    /*   dispatch({
          type: IS_LOADING_DATA_PROFILE,
      })
  
      dispatch({ //Esto se lo envía a combineReducer, el que está en el index
          type: GET_USER_POSTS,
          payload: []
      })
      dispatch({
          type: GET_RELATION_BETWEEN,
          payload: 
      })
      dispatch({
          type: IS_LOADING_DATA_PROFILE,
      })
      dispatch({
          type: SEE_COMMENTS_MULTI,
          payload: []
      })
      dispatch({
          type: IS_LOADING_COMMENTS_MULTI
      })
      dispatch({
          type: SEE_COMMENTS,
          payload: []
      })
      dispatch({
          type: IS_LOADING_COMMENTS
      }) */

    /*       dispatch({ //Esto se lo envía a combineReducer, el que está en el index
              type: IS_LOADING_GET_USER_INFO
          })
      
          dispatch({ //Esto se lo envía a combineReducer, el que está en el index
              type: GET_USER_INFO,
              payload: { user: {}, counters: {} }
          }) */
}

/* -----------------------------------------------*/
/* ---------->>> PAYMENT MANAGEMENT <<<-----------*/
/* -----------------------------------------------*/
export const makePayment = (payment, index) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/payment/pay`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(payment)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_PAYMENT_USER
                });
                dispatch({
                    type: PAYMENT_USER,
                    payload: respJson.data
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

//Managment blocked vendor in classifieds

/* ---------------------------------------------------------*/
/* ---------->>> VENDOR MANAGEMENT CLASSIFIEDS <<<-----------*/
/* ---------------------------------------------------------*/

export const blockVendorClassifieds = (idVendor) => async dispatch => {
    console.log()
    /* await fetch(`${urlServer}api/vendorblocking/block-cancel`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            sellerID: idVendor,
         
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_BLOCK_VENDOR
                });
                dispatch({
                    type: BLOCK_VENDOR,
                    payload: respJson.data
                });
                Toast.fire({
                    icon: 'success',
                    title: 'Bloqueando usuario'
                })
            }

        })
        .catch(error => {
            console.log()
        })
        */
}

export const unblockVendor = (blockVendor, index, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/vendorblocking/delete-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(blockVendor)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_BLOCK_VENDOR_LIST
                });
                dispatch({
                    type: UNBLOCK_VENDOR,
                    payload: index
                });
                Toast.fire({
                    icon: 'success',
                    title: 'Usuario desbloqueado'
                })
            }

        })
        .catch(error => {
            console.log()
        })
}

export const seeblockedVendorList = (history) => async dispatch => {
    await fetch(`${urlServer}api/vendorblocking/blocker-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            blockerID: localStorage().getItem('idUser')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_BLOCK_VENDOR_LIST
                });
                dispatch({
                    type: BLOCK_VENDOR_LIST,
                    payload: respJson.data
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

/* -----------------------------------------------*/
/* ---------->>> STORIES MANAGEMENT <<<-----------*/
/* -----------------------------------------------*/

export const viewStoriesHome = (history) => async dispatch => {
    await fetch(`${urlServer}stories/home-stories`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            entityID: localStorage().getItem('idProfile')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_STORIES_LIST
                });
                dispatch({
                    type: STORIES_LIST,
                    payload: respJson.data || []
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const seeStoriesHome = (id, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}stories/set-view`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            storyID: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()

        })
        .catch(error => {
            console.log()
        })
}

export const createStory = (body, history, setIsVisibleNewStory) => async dispatch => {
    dispatch({
        type: IS_LOADING_CREATE_STORY
    });
    await fetch(`${urlServer}stories/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            // 'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: body
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                history.go(0)
                setIsVisibleNewStory(false)
                dispatch({
                    type: CREATE_STORY,
                    payload: respJson.data
                });

            }

        })
        .catch(error => {
            console.log()
        })
}

export const deleteStoryHome = (id, setMyStoriesHome) => async dispatch => {
    //setMyStoriesHome([])
    // setMyStoriesHome({stories=>stories.filter(story=>story.id !== id)})
    //return;
    await fetch(`${urlServer}stories/delete`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            storyID: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                //setMyStoriesHome(stories=>stories.filter(story=>story.id !== id))
                dispatch({
                    type: IS_LOADING_STORIES_LIST
                });
                dispatch({
                    type: DELETE_STORY,
                    payload: id
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const seeStoryInfo = (id, history) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/stories/id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            id: id,
            visitorID: localStorage().getItem('idUser')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_STORY_INFO
                });
                dispatch({
                    type: STORY_INFO,
                    payload: respJson.data
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

/* -------------------------------------------------------*/
/* ---------->>> ARCHIVE STORIES MANAGEMENT <<<-----------*/
/* -------------------------------------------------------*/


export const archiveStoryHome = (id, setIdStoryActive, setMyStoriesHome) => async dispatch => {
    console.log()
    await fetch(`${urlServer}stories/to-archive`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            storyID: id
        })
    })
        .then(response => response.json())
        .then(respJson => {

            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Contenido guardado'
                })
            }

        })
        .catch(error => {
            console.log()
        })
}
export const unArchiveStoryHome = (id, setIdStoryActive, setMyStoriesHome) => async dispatch => {
    console.log()
    await fetch(`${urlServer}stories/to-unarchive`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            storyID: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()

            if (respJson.success === true) {
                Toast.fire({
                    icon: 'success',
                    title: 'Contenido removido'
                })
            }

        })
        .catch(error => {
            console.log()
        })
}
export const unArchiveStorySave = (id) => async dispatch => {
    console.log()
    await fetch(`${urlServer}stories/to-unarchive`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            storyID: id
        })
    })
        .then(response => response.json())
        .then(respJson => {

            dispatch({
                type: IS_LOADING_ARCHIVED_STORIES_LIST
            })
            if (respJson.success === true) {
                dispatch({
                    type: UN_ARCHIVED_STORY,
                    payload: id
                })
                Toast.fire({
                    icon: 'success',
                    title: 'Contenido removido'
                })
            }

        })
        .catch(error => {
            console.log()
        })
}

export const seeArchivedStoryHome = (history) => async dispatch => {

    await fetch(`${urlServer}stories/get-archived`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            entityID: localStorage().getItem('idProfile')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_ARCHIVED_STORIES_LIST
                });
                dispatch({
                    type: ARCHIVED_STORIES_LIST,
                    payload: respJson.data
                });
            }

        })
        .catch(error => {
            console.log()
        })
}
/* ---------------------------------------------------------*/
/* ---------->>> COMMUNITY REPORTS MANAGEMENT <<<-----------*/
/* ---------------------------------------------------------*/

export const reportCommunity = (communityID, typeOfReports, description) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/communityreport/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            communityID: communityID,
            entityID: localStorage().getItem('idUser'),
            typeOfReports: [typeOfReports],
            description: description
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()

        })
        .catch(error => {
            console.log()
        })
}

export const seeCommunityListIReported = () => async dispatch => {
    dispatch({
        type: IS_LOADING_LIST_COMMUNITY_I_REPORTED_FROM_LIST
    });
    await fetch(`${urlServer}api/communityreport/entity-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            entityID: localStorage().getItem('idUser')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: COMMUNITY_I_REPORTED_LIST,
                    payload: respJson.data
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const deleteReportCommunityList = (reportID, index) => async dispatch => {
    await fetch(`${urlServer}api/communityreport/delete-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            id: reportID,
            entityID: localStorage().getItem('idUser')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_LIST_COMMUNITY_I_REPORTED_FROM_LIST
                });
                dispatch({
                    type: CANCEL_COMMUNITY_I_REPORTED_FROM_LIST,
                    payload: index
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

/////ESTE ENDPOINT PERMITE ELIMINAR DE LA LISTA DE COMUNIDADES GENERAL PARA CANCELAR EL REPORTE, REDUCERS SIN CONFIGURAR
export const deleteReportCommunity = (communityID, index) => async dispatch => {
    await fetch(`${urlServer}api/communityreport/delete-community-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            communityID: communityID,
            entityID: localStorage().getItem('idUser')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_LIST_COMMUNITY_I_REPORTED
                });
                dispatch({
                    type: CANCEL_COMMUNITY_I_REPORTED,
                    payload: index
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const changeStateReportCommunity = (changeReportState, index) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/communityreport/change-state-user`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify(changeReportState)
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {
                dispatch({
                    type: IS_LOADING_MY_LIST_COMMUNITY_REPORTED
                });
                dispatch({
                    type: CHANGE_STATUS_COMMUNITY_REPORTED,
                    payload: index
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const seeMyCommunitiesReports = (id, reportState) => async dispatch => {
    dispatch({
        type: IS_LOADING_MY_LIST_COMMUNITY_REPORTED
    });
    await fetch(`${urlServer}api/communityreport/user-reported-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            entityID: localStorage().getItem('idUser')
        })
    })
        .then(response => response.json())
        .then(respJson => {
            console.log()
            if (respJson.success === true) {

                dispatch({
                    type: MY_LIST_COMMUNITY_REPORTED,
                    payload: respJson.data
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const seeUserRanking = (id) => async dispatch => {
    console.log()
    await fetch(`${urlServer}api/userranking/user-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            userID: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            dispatch({
                type: IS_LOADING_USER_RANKING
            });
            console.log()
            if (respJson.success === true) {

                dispatch({
                    type: USER_RANKING,
                    payload: respJson.data.reverse()
                });
            }

        })
        .catch(error => {
            console.log()
        })
}


export const seeStikers = () => async dispatch => {
    dispatch({
        type: LOAD_STIKERS
    });
    await fetch(`${urlServer}adminstickers/get-all`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    

    })
        .then(response => response.json())
        .then(respJson => {

            console.log()
            if (respJson.success === true) {

                dispatch({
                    type: GET_STIKERS,
                    payload: respJson.data
                });
            }

        })
        .catch(error => {
            console.log()
        })
}

export const createStikers = (sticker) => async dispatch => {
  
    await fetch(`${urlServer}adminstickers/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
 
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body:sticker

    })
        .then(response => response.json())
        .then(respJson => {

        
            if (respJson.success === true) {

          
            }

        })
        .catch(error => {
            
        })
}



